<div ngbAutofocus class="p-b-50">
  <div class="onboarding-flow-2024">
    <div class="onboarding-step text-center">
      <div class="m-t-30">
        <img [src]="contentService.logos[appService.app][appService.activeTheme].brand" style="width: 320px; margin: auto" />
        <div style="max-width: 800px; margin: 30px auto" class="t-18">
          {{ (subscribeOnly ? "onboarding.header_subscribe_only" : "onboarding.header_perpetual") | translate }}
        </div>

        <div class="container-fluid options m-b-100 m-t-10" data-cy="options">
          <div class="row">
            @if (!subscribeOnly) {
              <div class="m-b-10 col-sm-4">
                <div class="option" tabindex="0" (keyup.enter)="goToCheckout('Perpetual')" (keyup.space)="goToCheckout('Perpetual')" (click)="goToCheckout('Perpetual')">
                  <div class="option-title">
                    <img [src]="contentService.logos[appService.app][appService.activeTheme].perpetual" style="margin: auto" />
                  </div>
                  <div>
                    <h2 class="option-pill-descriptor">{{ isUpgrade ? "License Upgrade" : "License" }}</h2>
                  </div>
                  <div class="option-short-description">
                    {{ (isUpgrade ? "onboarding.option_short_description_upgrade" : "onboarding.option_short_description_not_upgrade") | translate }}
                  </div>
                  <div class="bundle-image">
                    <img [src]="contentService.logos[appService.app][appService.activeTheme].dawBoxScreen" style="height: 150px; margin: auto" />
                  </div>
                  @if (productService.studioOneStatus?.status != "can_redeem_fsp8") {
                    <div class="option-pricing">
                      @if (upgradableProducts) {
                        <span class="price d-block">{{ perpetualDisplayPrice | currency }}</span>
                      }
                      @if (activeCoupon) {
                        <span class="coupon d-block c-link-blue brandfont-bold">{{ activeCoupon.display_message }}</span>
                      }
                      @if (!upgradableProducts) {
                        <div><fa-icon [animation]="'spin'" icon="spinner"></fa-icon></div>
                      }
                      <span class="price-blurb">{{ "onboarding.one_time_payment" | translate }}</span>
                    </div>
                    <div class="m-t-30">
                      <span class="brand-btn-reverse">{{ "product_detail.buy_now" | translate }}</span>
                    </div>
                  }
                  @if (productService.studioOneStatus?.status == "can_redeem_fsp8") {
                    <div class="option-pricing">
                      <!-- <span class="price d-block" style="text-decoration: line-through" *ngIf="upgradableProducts">{{ perpetualDisplayPrice | currency }}</span> -->
                      <span class="price d-block c-green">$0.00</span>
                      @if (!upgradableProducts) {
                        <div><fa-icon [animation]="'spin'" icon="spinner"></fa-icon></div>
                      }
                      <span class="price-blurb">You are elligible to redeem Fender Studio Pro 8 for free!</span>
                      <div class="m-t-30">
                        <button class="brand-btn-reverse">{{ (redeeming ? "general.redeeming_dots" : "general.redeem") | translate }}</button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            <div [class]="subscribeOnly ? 'col-sm-6 m-b-10' : 'col-sm-4 m-b-10'">
              <div class="option" tabindex="0" (keyup.enter)="continueSphere('annual')" (keyup.space)="continueSphere('annual')" (click)="continueSphere('annual')">
                <div class="option-title">
                  <img [src]="contentService.logos[appService.app][appService.activeTheme].subscription" alt="Studio One Plus icon" />
                  <span class="m-b-0 brandfont-black d-block m-t-5">Annual</span>
                </div>
                <div>
                  <h2 class="option-pill-descriptor">{{ "onboarding.license_plus_access" | translate }}</h2>
                </div>
                <div class="option-short-description">{{ "onboarding.license_plus_access_description" | translate }}</div>
                <div class="bundle-image">
                  <img [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxAnnual" style="width: 100%; max-width: 250px; margin: auto" />
                </div>
                <div class="option-pricing">
                  <span class="price">$179.99/yr</span>
                  <br />
                  <span class="price-blurb">{{ "onboarding.subscription_continues_until_canceled" | translate }}</span>
                </div>
                <div class="m-t-30">
                  @if (!alreadySubscribed) {
                    <button class="brand-btn-reverse">{{ "general.subscribe" | translate }}</button>
                  }
                  @if (alreadySubscribed) {
                    <div>
                      @if (alreadySubscribed == "annual") {
                        <fa-icon class="c-green" icon="circle-check"></fa-icon>
                        {{ "onboarding.already_subscribed" | translate }}
                        <br />
                        <a class="small-btn">{{ "onboarding.manage_subscription" | translate }}</a>
                      }
                      @if (alreadySubscribed == "monthly") {
                        <a class="brand-btn-reverse">{{ "onboarding.upgrade_to_annual" | translate }}</a>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div [class]="subscribeOnly ? 'col-sm-6 m-b-10' : 'col-sm-4 m-b-10'">
              <div class="option" tabindex="0" (keyup.enter)="continueSphere('monthly')" (keyup.space)="continueSphere('monthly')" (click)="continueSphere('monthly')">
                <div class="option-title">
                  <img [src]="contentService.logos[appService.app][appService.activeTheme].subscription" alt="Studio One Plus icon" />
                  <span class="m-b-0 brandfont-black d-block m-t-5">Monthly</span>
                </div>
                <div>
                  <h2 class="option-pill-descriptor">{{ "onboarding.access_only" | translate }}</h2>
                </div>
                <div class="option-short-description">{{ "onboarding.access_only_description" | translate }}</div>
                <div class="bundle-image">
                  <img [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxMonthly" style="width: 100%; max-width: 250px; margin: auto" />
                </div>
                <div class="option-pricing">
                  <span class="price">$19.99/mo</span>
                  <br />
                  <span class="price-blurb">{{ "onboarding.sub_continues_until_canceled" | translate }}</span>
                </div>
                <div class="m-t-30">
                  @if (!alreadySubscribed) {
                    <button class="brand-btn-reverse">Subscribe</button>
                  }
                  @if (alreadySubscribed) {
                    <div>
                      <fa-icon class="c-green" icon="circle-check"></fa-icon>
                      {{ "onboarding.already_subscribed" | translate }}
                      <br />
                      <a class="small-btn" [routerLink]="['/account/plan']">{{ "onboarding.manage_subscription" | translate }}</a>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="col-md-12 m-t-30 t-18" style="margin-top: 50px">
              {{ "onboarding.already_have_product_key" | translate }}&nbsp;&nbsp;
              <button class="c-link-blue link" data-cy="continue-to-home-link" (click)="showRegisterProduct()">
                {{ "onboarding.register_here" | translate }}
                <fa-icon icon="chevron-right"></fa-icon>
              </button>
              <br />
            </div>
            <div class="col-md-12 m-t-30">
              <button class="c-link-blue link t-18" data-cy="continue-to-home-link" (click)="continueFree()">
                {{ "onboarding.return_to_mypresonus" | translate }}
                <fa-icon icon="chevron-right"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <fui-footer></fui-footer>
</div>
